import { fromFetch } from 'rxjs/fetch';
import UrlExtensions from 'utils/urlExtension';

/**
 * @private
 *
 * The function returns a the User profile URL.
 *
 * @returns user profile URL string with parameters for the user's profile page, including IP address.
 */
function getUserProfileUrl() {
  const location = window.location;
  const path = '/getUserProfile';
  const ip = UrlExtensions.getParameterValue(location, 'ip');

  const url = UrlExtensions.setParameters(path, {
    ip,
  });
  return url;
}

export default fromFetch(getUserProfileUrl(),
  {
    'credentials': 'include',
    headers: {
      'Accept': 'application/json',
    }
  });
